import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//首页
const index = r => require.ensure([], () => r(require('./views/index')), 'index');

//positioning
const positionConcept = r => require.ensure([], () => r(require('./views/positioning/concept')), 'positionConcept');
const positionHistory = r => require.ensure([], () => r(require('./views/positioning/history')), 'positionHistory');
const positionIntroduce = r => require.ensure([], () => r(require('./views/positioning/introduce')), 'positionIntrodoce');

//service
const serviceConsulting = r => require.ensure([], () => r(require('./views/service/consulting')), 'serviceConsulting');
const serviceClients = r => require.ensure([], () => r(require('./views/service/clients')), 'serviceClients');

//about
const aboutContact = r => require.ensure([], () => r(require('./views/about/contact')), 'aboutContact');
const aboutIndex = r => require.ensure([], () => r(require('./views/about/index')), 'aboutIndex');
const aboutTeams = r => require.ensure([], () => r(require('./views/about/teams')), 'aboutTeams');

//insights
const insightsIndex = r => require.ensure([], () => r(require('./views/insights/index')), 'insightsIndex');
const insightsDetails = r => require.ensure([], () => r(require('./views/insights/details')), 'insightsDetails');


//news
const newsIndex = r => require.ensure([], () => r(require('./views/news/index')), 'newsIndex');
const newsDetails = r => require.ensure([], () => r(require('./views/news/details')), 'newsDetails');

let router =  new VueRouter({
    mode: 'history',
    linkActiveClass: 'active',
    routes:[
        {
            path: "*",
            redirect: "/index"
        },
        {
            path: '/index',
            meta: {
                title: 'Trout & Partners'
            },
            component: index
        },
        {
            path: '/positioning/concept',
            meta: {
                title: 'Concept | Trout & Partners<'
            },
            component: positionConcept
        },
        {
            path: '/positioning/history',
            meta: {
                title: 'History | Trout & Partners'
            },
            component: positionHistory
        },
        {
            path: '/positioning/introduce',
            meta: {
                title: 'Introduce | Trout & Partners'
            },
            component: positionIntroduce
        },
        {
            path: '/service/consulting',
            meta: {
                title: 'Consulting | Trout & Partners'
            },
            component: serviceConsulting
        },
        {
            path: '/service/clients',
            meta: {
                title: 'Client | Trout & Partners'
            },
            component: serviceClients
        },
        {
            path: '/about/index',
            meta: {
                title: 'About Us | Trout & Partners'
            },
            component: aboutIndex
        },
        {
            path: '/about/contact',
            meta: {
                title: 'Contact Us | Trout & Partners'
            },
            component: aboutContact
        },
        {
            path: '/about/teams',
            meta: {
                title: 'Teams | Trout & Partners'
            },
            component: aboutTeams
        },
        {
            path: '/insights/index',
            meta: {
                title: 'Insights | Trout & Partners'
            },
            component: insightsIndex
        },
        {
            path: '/insights/details',
            meta: {
                title: 'Insights | Trout & Partners'
            },
            component: insightsDetails
        },
        {
            path: '/news/index',
            meta: {
                title: 'News | Trout & Partners'
            },
            component: newsIndex
        },
        {
            path: '/news/details',
            meta: {
                title: 'News | Trout & Partners'
            },
            component: newsDetails
        },
    ]
})

router.beforeEach ((to, from, next) => {
    window.scrollTo(0, 0)
    document.title = to.meta.title || 'Trout & Partners'
    next(true);
})


export default router;
